(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const banners = document.querySelectorAll('.hero-banner[data-parallax="true"]');
    if (banners.length === 0) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let ticking = false;

    function update() {
      const scrollY = window.scrollY || document.documentElement.scrollTop;

      banners.forEach(function (banner) {
        const top = banner.offsetTop;
        const height = banner.offsetHeight;
        const scrolledInto = Math.max(0, Math.min(height, scrollY - top));
        banner.style.setProperty('--parallax-offset', scrolledInto + 'px');
      });

      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const heroes = document.querySelectorAll('.hero[data-parallax="true"]');
    if (heroes.length === 0) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let ticking = false;
    function update() {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      heroes.forEach(function (hero) {
        const rect = hero.getBoundingClientRect();
        const top = hero.offsetTop;
        const height = hero.offsetHeight;
        const scrolledInto = Math.max(0, Math.min(height, scrollY - top));
        hero.style.setProperty('--parallax-offset', scrolledInto + 'px');
      });
      ticking = false;
    }
    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
